module.exports = __webpack_public_path__ + "media/72.94b87d12.wav";